<template>
    <img src="/images/promo/hero-section/laptop.png"
     alt="Laptop" />
</template>

<script>
export default {};
</script>
